import { nectarApi } from '@/features/nectar/api/client'
import { type UseQueryResult, useQuery } from '@tanstack/react-query'

export type EnrollmentCounts = {
  active: number
  completed: number
  closed: number
  total: number
}

export const useFetchEnrollmentCounts = (): UseQueryResult<EnrollmentCounts> => {
  return useQuery({
    queryKey: ['enrollment-counts'],
    queryFn: () => nectarApi.get<EnrollmentCounts>('/v1/enrollments/counts'),
    staleTime: 30_000
  })
}
